import React from "react";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
const imagePath = (name) => `/images/cursos/${name}.png`;

const CourseFour = () => {
  return (
    <>
      <SEO title="Cursos Italiano" />
      <Layout>
        <div className="edu-course-area edu-section-gap-courses bg-color-white" id="courses-info">
          <div className="container">
            {/* Registration Header */}
            <div className="row g-4 mb-4">
              <div className="col-12">
                <div className="curso-card h-100 d-flex flex-column align-items-center justify-content-center">
                  <h3>INSCRIPCIONES AGOSTO 2026</h3>
                  <h5>Comienzo 03/08/2026 - Fin 14/12/2026</h5>
                </div>
              </div>
            </div>

            {/* Registration Button */}
            <div className="row g-4 mb-4 justify-content-center">
              <div className="col-md-8">
                <div className="curso-card text-center d-flex flex-column align-items-center justify-content-center">
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSfDWLpCsENnyFPalc7IHTLN2iE_cwDIWGF6ewqcs_IafP-Fzw/viewform?usp=sharing&ouid=110288629480795366484" target="_blank" rel="noopener noreferrer" className="d-inline-block" style={{ cursor: 'pointer' }}>
                    <img src={imagePath("btn_inscribirse_small")} alt="Inscribirse" className="img-fluid" style={{ maxWidth: '200px', height: 'auto' }} />
                  </a>
                </div>
              </div>
            </div>

            {/* Courses Grid */}
            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <div className="curso-card text-center"><img src={imagePath("A1")} alt="A1" className="img-fluid" /></div>
              </div>
              <div className="col-md-6">
                <div className="curso-card text-center"><img src={imagePath("A2")} alt="A2" className="img-fluid" /></div>
              </div>
              <div className="col-md-6">
                <div className="curso-card text-center"><img src={imagePath("CELI")} alt="CELI" className="img-fluid" /></div>
              </div>
              <div className="col-md-6">
                <div className="curso-card text-center"><img src={imagePath("COCINA")} alt="Cocina" className="img-fluid" /></div>
              </div>
              <div className="col-md-6">
                <div className="curso-card text-center"><img src={imagePath("CONV")} alt="Conversa" className="img-fluid" /></div>
              </div>
              <div className="col-md-6">
                <div className="curso-card text-center"><img src={imagePath("Precios_Cursos")} alt="Precios Cursos" className="img-fluid" /></div>
              </div>
            </div>

          </div>
        </div>
      </Layout>
    </>
  );
};

export default CourseFour;
